import { device } from 'device.js'

class DevicesService {
  static get devices() {
    return device
  }

  static get isMobile(): boolean {
    return device.mobile || device.tablet
  }

  static get isDesktop(): boolean {
    return device.desktop
  }
}

export default DevicesService
